var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0331 6.26698V19.761H0.613102V6.26698H5.0331ZM2.8231 0.650986C3.37777 0.650986 3.85444 0.850319 4.2531 1.24899C4.65177 1.63032 4.8511 2.10699 4.8511 2.67899C4.8511 3.23365 4.65177 3.71032 4.2531 4.10898C3.85444 4.50765 3.37777 4.70698 2.8231 4.70698C2.2511 4.70698 1.76577 4.50765 1.3671 4.10898C0.985768 3.71032 0.795102 3.23365 0.795102 2.67899C0.795102 2.10699 0.985768 1.63032 1.3671 1.24899C1.76577 0.850319 2.2511 0.650986 2.8231 0.650986ZM12.3419 6.26698V8.06099C13.4166 6.62232 14.8899 5.90298 16.7619 5.90298C18.5646 5.90298 19.8819 6.50099 20.7139 7.69699C21.2513 8.49432 21.5199 9.72499 21.5199 11.389V19.761H17.0739V12.117C17.0739 11.4063 17.0046 10.8777 16.8659 10.531C16.5886 9.85499 15.9733 9.51699 15.0199 9.51699C13.9799 9.51699 13.2519 9.91565 12.8359 10.713C12.6106 11.129 12.4979 11.7443 12.4979 12.559V19.761H8.07795V6.26698H12.3419Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.60724fe320e536f39a44dee4e467e6cd.svg";
export { ForwardRef as ReactComponent };